import { FOfferType, isCommercial } from '../../../utils/offer_type';

export enum EVertical {
  residential = 'residential',
  commercial = 'commercial',
  newBuildings = 'newBuildings',
}

/**
 * Определяет вертикаль, по которой происходит поиск
 */
export function getVertical(offerType: FOfferType): EVertical {
  switch (true) {
    case (offerType === FOfferType.FlatNew):
      return EVertical.newBuildings;
    case (isCommercial(offerType)):
      return EVertical.commercial;
    default:
      return EVertical.residential;
  }
}
